export const EmptyDataSports = (props: Props) => {
  return <div className='text-primary text-18 font-bold'>일치하는 항목이 없습니다.</div>
}
